







export const nationalityOptions: string[] = [
    "Filipino",
    "Afghan",
    "Albanian",
    "Algerian",
    "American",
    "Andorran",
    "Angolan",
    "Antiguan and Barbudan",
    "Argentine",
    "Armenian",
    "Australian",
    "Austrian",
    "Azerbaijani",
    "Bahamian",
    "Bahraini",
    "Bangladeshi",
    "Barbadian",
    "Belarusian",
    "Belgian",
    "Belizean",
    "Beninese",
    "Bhutanese",
    "Bolivian",
    "Bosnian",
    "Botswanan",
    "Brazilian",
    "Bruneian",
    "Bulgarian",
    "Burkinabé",
    "Burmese",
    "Burundian",
    "Cabo Verdean",
    "Cambodian",
    "Cameroonian",
    "Canadian",
    "Central African",
    "Chadian",
    "Chilean",
    "Chinese",
    "Colombian",
    "Comorian",
    "Congolese (Congo-Brazzaville)",
    "Congolese (Congo-Kinshasa)",
    "Costa Rican",
    "Croatian",
    "Cuban",
    "Cypriot",
    "Czech",
    "Danish",
    "Djiboutian",
    "Dominican",
    "Dutch",
    "East Timorese",
    "Ecuadorean",
    "Egyptian",
    "Emirati",
    "Equatorial Guinean",
    "Eritrean",
    "Estonian",
    "Eswatini",
    "Ethiopian",
    "Fijian",
    "Finnish",
    "French",
    "Gabonese",
    "Gambian",
    "Georgian",
    "German",
    "Ghanaian",
    "Greek",
    "Grenadian",
    "Guatemalan",
    "Guinean",
    "Guinea-Bissauan",
    "Guyanese",
    "Haitian",
    "Honduran",
    "Hungarian",
    "Icelander",
    "Indian",
    "Indonesian",
    "Iranian",
    "Iraqi",
    "Irish",
    "Israeli",
    "Italian",
    "Ivorian",
    "Jamaican",
    "Japanese",
    "Jordanian",
    "Kazakhstani",
    "Kenyan",
    "Kiribati",
    "Kittitian and Nevisian",
    "Kuwaiti",
    "Kyrgyz",
    "Laotian",
    "Latvian",
    "Lebanese",
    "Liberian",
    "Libyan",
    "Liechtensteiner",
    "Lithuanian",
    "Luxembourger",
    "Macedonian",
    "Malagasy",
    "Malawian",
    "Malaysian",
    "Maldivian",
    "Malian",
    "Maltese",
    "Marshallese",
    "Mauritanian",
    "Mauritian",
    "Mexican",
    "Micronesian",
    "Moldovan",
    "Monacan",
    "Mongolian",
    "Montenegrin",
    "Moroccan",
    "Mozambican",
    "Namibian",
    "Nauruan",
    "Nepalese",
    "New Zealander",
    "Nicaraguan",
    "Nigerien",
    "Nigerian",
    "North Korean",
    "Norwegian",
    "Omani",
    "Pakistani",
    "Palauan",
    "Palestinian",
    "Panamanian",
    "Papua New Guinean",
    "Paraguayan",
    "Peruvian",
    "Polish",
    "Portuguese",
    "Qatari",
    "Romanian",
    "Russian",
    "Rwandan",
    "Saint Lucian",
    "Salvadoran",
    "Samoan",
    "San Marinese",
    "Sao Tomean",
    "Saudi Arabian",
    "Scottish",
    "Senegalese",
    "Serbian",
    "Seychellois",
    "Sierra Leonean",
    "Singaporean",
    "Slovak",
    "Slovenian",
    "Solomon Islander",
    "Somali",
    "South African",
    "South Korean",
    "Spanish",
    "Sri Lankan",
    "Sudanese",
    "Surinamese",
    "Swazi",
    "Swedish",
    "Swiss",
    "Syrian",
    "Tajik",
    "Tanzanian",
    "Thai",
    "Togolese",
    "Tongan",
    "Trinidadian or Tobagonian",
    "Tunisian",
    "Turkish",
    "Turkmen",
    "Tuvaluan",
    "Ugandan",
    "Ukrainian",
    "Uruguayan",
    "Uzbekistani",
    "Vanuatuan",
    "Venezuelan",
    "Vietnamese",
    "Welsh",
    "Yemeni",
    "Zambian",
    "Zimbabwean"
];




export const educationLevelOptions: string[] = [
    "High School",
    "Associate Degree",
    "Bachelor's Degree",
    "Master's Degree",
    "Doctorate",
    "None",
    "Other",
]


//Gender Options

export const genderOptions: string[] = [
    "Male",
    "Female",
    "Lesbian",
    "Gay",
    "Bisexual",
    "Transgender",
    "Queer",
    "Non-binary",
    "Pansexual",
    "Other"
]

export const civilStatusOptions: string[] = [
    "Single",
    "Married",
    "Divorced",
    "Widowed",
    "Separated",
    "Undisclosed"
]


//Language Options

export const languageOptions: string[] = [
    'English',
    'Filipino',
    'Spanish',
    'French',
    'German',
    'Chinese',
    'Japanese',
    'Korean',
    'Italian',
    'Portuguese',
    'Russian',
    'Hindi',
    'Arabic',
    'Bengali',
    'Punjabi',
    'Javanese',
    'Indonesian',
    'Vietnamese',
    'Urdu',
    'Thai',
    'Turkish',
    'Malay',
    'Persian',
    'Swahili',
    'Tamil',
    'Marathi',
    'Telugu',
    'Kannada',
    'Gujarati',
    'Malayalam',
    'Odia',
    'Amharic',
    'Nepali',
    'Burmese',
    'Khmer',
    'Sinhala',
    'Lao',
    'Mongolian',
    'Georgian',
    'Armenian',
    'Kazakh',
    'Uzbek',
    'Azerbaijani',
    'Hebrew',
    'Greek',
    'Hungarian',
    'Polish',
    'Ukrainian',
    'Czech',
    'Swedish'
];


//Language Pair

export const languagePair: { code: string, name: string }[] = [
    { code: 'en', name: 'English' },
    { code: 'fil', name: 'Filipino' },
    { code: 'es', name: 'Spanish' },
    { code: 'fr', name: 'French' },
    { code: 'de', name: 'German' },
    { code: 'zh', name: 'Chinese' },
    { code: 'ja', name: 'Japanese' },
    { code: 'ko', name: 'Korean' },
    { code: 'it', name: 'Italian' },
    { code: 'pt', name: 'Portuguese' },
    { code: 'ru', name: 'Russian' },
    { code: 'hi', name: 'Hindi' },
    { code: 'ar', name: 'Arabic' },
    { code: 'bn', name: 'Bengali' },
    { code: 'pa', name: 'Punjabi' },
    { code: 'jv', name: 'Javanese' },
    { code: 'id', name: 'Indonesian' },
    { code: 'vi', name: 'Vietnamese' },
    { code: 'ur', name: 'Urdu' },
    { code: 'th', name: 'Thai' },
    { code: 'tr', name: 'Turkish' },
    { code: 'ms', name: 'Malay' },
    { code: 'fa', name: 'Persian' },
    { code: 'sw', name: 'Swahili' },
    { code: 'ta', name: 'Tamil' },
    { code: 'mr', name: 'Marathi' },
    { code: 'te', name: 'Telugu' },
    { code: 'kn', name: 'Kannada' },
    { code: 'gu', name: 'Gujarati' },
    { code: 'ml', name: 'Malayalam' },
    { code: 'or', name: 'Odia' },
    { code: 'am', name: 'Amharic' },
    { code: 'ne', name: 'Nepali' },
    { code: 'my', name: 'Burmese' },
    { code: 'km', name: 'Khmer' },
    { code: 'si', name: 'Sinhala' },
    { code: 'lo', name: 'Lao' },
    { code: 'mn', name: 'Mongolian' },
    { code: 'ka', name: 'Georgian' },
    { code: 'hy', name: 'Armenian' },
    { code: 'kk', name: 'Kazakh' },
    { code: 'uz', name: 'Uzbek' },
    { code: 'az', name: 'Azerbaijani' },
    { code: 'he', name: 'Hebrew' },
    { code: 'el', name: 'Greek' },
    { code: 'hu', name: 'Hungarian' },
    { code: 'pl', name: 'Polish' },
    { code: 'uk', name: 'Ukrainian' },
    { code: 'cs', name: 'Czech' },
    { code: 'sv', name: 'Swedish' }
];


export const dangerousSites: string[] = [
    'examplemalicioussite.com',
    'youporn.com',
    'pornhub.com',
    'youjizz.com',
    'redtube.com',
    'googlehammer.com',
    'xvideos.com',
    'pinayflix.com',
    'x-hamster.com',
    'adultfriendfinder.com',
    'spankwire.com',
    'tube8.com',
    'hentaihaven.org',
    'e621.net',
    'xvideos.es',
    'tnaflix.com',
    '8muses.com',
    'alumita.com',
    'chaturbate.com',
    'newgrounds.com',
    'fapdu.com',
    'motherless.com',
    'xvideos3.com',
    'xnxx.com',
    'hentaimama.com',
    'youporn.com',
    'fapdu.com',
    'fapnation.com',
    'eurosexparty.com',
    'empflix.com',
    'motherless.com',
    'nuvid.com',
    'vidz.com',
    'hentaiparadise.com',
    'xfun.com',
    'youjizz.com',
    'hentaihaven.org',
    'sex.com',
    'adultwork.com',
    'adultfriendfinder.com',
    'iXXX.com',
    'luscious.net',
    'hentaihaven.org',
    'sexylink.com',
    'redtube.com',
    'tnaflix.com',
    'zefix.com',
    'tinychat.com',
    'gfycat.com',
    'skype.com',
    'chaturbate.com',
    'gaytube.com',
    'gaybears.com',
    'vidmama.com',
    'adult.com',
    'black.com',
    'shemale.com',
    'slutload.com',
    'swallows.com',
    'hentaimama.com',
    'e621.net',
    'xhamster.com',
    'beeg.com',
    'nudevista.com',
    'xnxx.com',
    'fapdu.com',
    'youjizz.com',
    'hentaihaven.org',
    'spankwire.com',
    'newgrounds.com',
    'eurosexparty.com',
    'hentaihaven.org',
    'xvideos.es',
    'fapdu.com',
    'empflix.com',
    'slutload.com',
    'xxnx.com',
    'sxyprn.com',
    'fapdu.com',
    'tnaflix.com',
    '8muses.com',
    'naughtyamerica.com',
    'swingingheaven.com',
    'dirty.com',
    '3movs.com',
    'myfreecams.com',
    '3gpmp4.com',
    'auntypriya.com',
    'drtuber.com',
    'hentaimama.com',
    'sex.com',
    'spankwire.com',
    'youporn.com',
    'adultwork.com',
    'xnxx.com',
    'myfreecams.com',
    'fapnation.com',
    'hentaihaven.org',
    'hentaihaven.org',
    'perfectgirls.net',
    'boomporn.com',
    '4tube.com',
    'porn300.com',
    'empflix.com',
    'porn300.com',
    'hentaihaven.org',
];


export const disposableEmailDomains = [
  // Popular temp mail services
  "maildrop.cc",
  "mailinator.com",
  "guerrillamail.com",
  "10minutemail.com",
  "tempmail.com",
  "temp-mail.org",
  "yopmail.com",
  "dispostable.com",
  "trashmail.com",
  "getnada.com",
  "fakeinbox.com",
  "sharklasers.com",

  // Variants / mirrors
  "mailinator.net",
  "mailinator.org",
  "maildrop.email",
];